import { physiosPageContent } from "../../data/physiosPageContent";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import "../../styles/physio.css";
import Img1 from "../../images/physio-create-plan-img.png"
import Img2 from "../../images/exercises-list-img.png";
// Custom Treatment Plans section
export default function TreatmentPlans() {
  const currentLang = useCurrentLang();
  const t = physiosPageContent[currentLang];
  const steps = [
    {
      title: t.treatmentP.PERKS.title1,
      desc: t.treatmentP.PERKS.desc1,
    },
    {
      title: t.treatmentP.PERKS.title2,
      desc: t.treatmentP.PERKS.desc2,
    },
    {
     title: t.treatmentP.PERKS.title3,
      desc: t.treatmentP.PERKS.desc3,
    },
    {
      title: t.treatmentP.PERKS.title4,
      desc: t.treatmentP.PERKS.desc4,
    },
  ];

  return (
    <section id="plans" className="physio-section physio-plans">
      <div className="glass-card">
        <span className="physio-eyebrow-NOT-F">{t.treatmentP.s}</span>
        <h2>{t.treatmentPheader}</h2>
        <div className="physio-divider" />
        <p className="section-lead">
          {t.treatmentP.desc}
        </p>

        <div className="plans-layout">
          <div>
          <div className="plan-img">

            <img src={Img1} alt="Create costum plan in Physio Console" 
              width="800"
              height="320"
              loading="lazy"
              />
          </div>
          <h1></h1>
          <div className="plan-img">
            <img src={Img2} alt="Create costum plan in Physio Console" 
              width="800"
              height="320"
              loading="lazy"
              />
          </div>
          </div>

          <div>
            <div className="plan-steps">
              {steps.map(({ title, desc }, i) => (
                <div className="plan-step" key={i}>
                  <div className="step-num">{i + 1}</div>
                  <div className="step-body">
                    <h4>{title}</h4>
                    <p>{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
